export * from './sfaSponsorPill.types';
export { default as SfaSponsorPill } from './sfaSponsorPill.component';
